<template>
    <main-site>
        <template #main_content>
            <inertia-head>
                <title v-if="!pageContent.header_title" name="title">{{ pageTitle }}</title>
                <title v-else name="title">{{ pageContent.meta_title ?? pageContent.header_title }}</title>
                <meta v-show="pageContent" name="description" :content="`${pageContent.meta_description ?? textShorter(pageContent.header_body, null)}`"/>
                    <meta v-show="pageContent && Array.isArray(pageContent.keyword)" name="keywords" :content="`${JSON.parse(pageContent.keyword ?? '[]').toString()}`"/>
                <meta v-show="pageContent" property="og:title" :content="`${pageContent.meta_title ?? pageContent.header_title}`"/>
                <meta v-show="pageContent" property="og:description" :content="`${pageContent.meta_description ?? textShorter(pageContent.header_body, null)}`"/>
                <meta v-show="pageContent" name="twitter:title" :content="`${pageContent.meta_title ?? pageContent.header_title}`">
                <link v-if="!pageContent.canonical_tag" rel="canonical" :href="canonicalLink"/>
                <link v-else rel="canonical" :href="`${pageContent.canonical_tag}`"/>
                <meta v-if="pageContent.noindex_tag" name="robots" :content="`${pageContent.noindex_tag}`"/>
            </inertia-head> 

            <loading :show="isLoading"/>

            <div class="container mx-auto pt-[50px] lg:pt-1">
                <!--    searchBox        -->

                <div class="rounded-2xl bg-white shadow-xl mx-3 sm:mx-auto my-2">
                    <div class="p-4 mx-2">
                        <h1 v-if="pageContent" class="text-3xl font-bold text-gray-600 text-center mb-3">{{ pageContent.header_title }}</h1>

                        <p v-show="pageContent && pageContent.header_body" class="text-center">
                            <span class="text-left pagecontent-header-body mt-3" v-html="pageContentHeaderBody"></span>
                            <span v-if="! showMore" class="text-left pagecontent-header-body mt-3 hidden" v-html="pageContent.header_body"></span>
                            <span @click="showMoreButton" class="show-more-button ml-1"> {{ showMoreText }} </span>
                        </p>
                    </div>

                    <hr v-if="pageContent && (pageContent.header_body || pageContent.header_title)"  class="my-4">

                    <div class="grid grid-cols-8 md:grid-cols-6 gap-6 sm:px-3 text-center">
                        <div class=" sm:col-span-2 min-w-1/4 col-span-8 ">
                            <label for="speciality" class="mr-3 text-lg">Speciality:</label>
                            <select class="rounded-full w-48 min-w-3/4 text-center bg-white focus:bg-indigo-100 mt-2 p-2 border border-gray-300 shadow-md px-9"
                                    v-model="masterSortForm.category"
                                    @change="getCategoryData"
                                    aria-label="speciality">
                                <option value="null">Choose</option>
                                <option v-for="(category,key) in $page.props.categories" :key="key" :value="category.id">{{ category.title }}</option>
                            </select>
                        </div>
                        <div class=" sm:col-span-2 col-span-8 flex items-center justify-center mt-2">
                            <label for="city" class="mr-3 text-lg min-w-1/4">Location:</label>
                            <VSelect
                                class="w-60"
                                aria-label="city"
                                placeholder="Search your city"
                                :options="cities"
                                :get-option-label="vSelectLabel"
                                v-model="masterSortForm.city"
                                :reduce="data => data.url"
                                :filter="customCityFilterPattern"
                                @update:modelValue="getCategoryData">

                                <!-- Custom Chevron Icon Slot -->
                                <template #open-indicator>
                                    <span class="material-icons text-gray-600 pb-3 pt-2" style="font-size: 30px">search</span>
                                </template>
                                
                            </VSelect>
                            <!-- <select class="rounded-full w-48 min-w-3/4 text-center align-items-center bg-white focus:bg-indigo-100 mt-2 p-2 border border-gray-300 shadow-md px-9"
                                    v-model="masterSortForm.city"
                                    @change="getCategoryData"
                                    aria-label="city">
                                <option :value="null">Choose</option>
                                <option v-for="(city,key) in cities" :key="key" :value="city.url">{{ city.title }} 
                                    {{ city && city.state && city.state.short_title ? `(${city.state.short_title})` : ``}}</option>
                            </select> -->
                        </div>
                        <div class=" sm:col-span-2 col-span-8 place-center flex self-center justify-center">
                            <label class="mr-3 text-lg self-center">Gender:</label>
                            <input hidden
                                   v-model="masterSortForm.gender"
                            >
                            <div class="rounded-full border border-gray-300 p-1 w-min shadow-md">
                                <span class="border-r border-gray-300 px-2 cursor-pointer text-lg"
                                      @click="masterSortForm.gender='male' ,getCategoryData()"
                                      :class="masterSortForm.gender==='male' ? 'bg-green-400 text-white rounded-l-full' : ''">Male</span>
                                <span class="border-r border-gray-300 px-2 cursor-pointer text-lg"
                                      @click="masterSortForm.gender='female' ,getCategoryData()"
                                      :class="masterSortForm.gender==='female' ? 'bg-green-400 text-white' : ''">Female</span>
                                <span class="px-2 cursor-pointer text-lg"
                                      @click="masterSortForm.gender='both' ,getCategoryData()"
                                      :class="masterSortForm.gender==='both' ? 'bg-green-400 text-white rounded-r-full' : ''">Both</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="isClientSide()" class="flex flex-wrap items-center px-3 pb-5 pt-5 justify-center">
                        <div class="flex">
                            <div> 
                                <p class="text-gray-500 text-lg"> Need help? Call us! </p>
                            </div>
                            <div>
                                <a :href="`tel:${this.$page.props && this.$page.props.configs ? this.$page.props.configs.phone : '-'}`"
                                    class="custom-button bg-yellow-400 mt-2 :sm:mt-0 text-lg shadow-md px-3 py-1 mx-3 mb-2 rounded-full
                                    text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500"
                                > {{ this.$page.props && this.$page.props.configs ? this.$page.props.configs.phone : '-' }} </a>
                            </div>
                        </div>
                        <div class="sm:my-0 my-5">
                            <div class="bg-[#10B981] rounded-lg p-3 text-white text-base font-bold">
                                Happy Trainers defines trainers' level and price based on their skills.
                            </div>
                        </div>
                    </div>
                </div>
                <!--    mastersList        -->
                <!-- <div v-if="masters.data.length===0" class="container rounded-2xl bg-white shadow-xl mx-3 sm:mx-auto  my-2">
                    <div class="p-5 self-center">
                        <h5 class="text-2xl"><span class="mx-2 material-icons">info</span>No results were found for your search</h5>
                    </div>
                </div> -->
                <main>
                    <section v-for="(master,key) in masters.data" :key="key" class="grid grid-cols-12 gap-2 mx-3">
                        <div class="rounded-2xl shadow-lg bg-white col-span-12 sm:col-span-8 my-1">
                            <div class="md:flex sm:divide-x-2 divide-gray-500">
                                <div class="sm:p-3 p-1 sm:w-4/6">
                                    <figure class="sm:p-4 p-2 sm:flex grid">
                                        <div class="sm:grid flex sm:justify-center justify-start sm:mb-0 mb-4">
                                            <div class="items-center">
                                                <Link :href="master.profileUrl">
                                                    <div class="master-lists-avatar rounded-full mx-auto border ring ring-offset-2 ring-gray-300 shadow-md">
                                                        <img :src="`${master.user?.profile_photo_url}?w=160&h=160`"
                                                            :loading="key == 0 ? 'eager' : 'lazy'"
                                                            :alt="`${this.service_category.title} ${master.user?.fullName}`"
                                                            width="160"
                                                            height="160"
                                                            class="img-cover rounded-full">
                                                    </div>
                                                </Link>
                                                <div class="flex justify-center items-center mt-3">
                                                    <span class="material-icons text-green-600 text-3xl">location_on</span>
                                                    <span class="font-bold"> {{ master.user?.city?.title }} </span>
                                                </div>
                                            </div>
                                            <div class="sm:hidden block ml-3 mt-5">
                                                <Link :href="master.profileUrl">
                                                    <h2 class="text-2xl font-bold my-2 text-gray-700">
                                                        {{ master.user?.fullName }}
                                                    </h2>
                                                </Link>
                                                <div>
                                                    <span class="master-level my-2"> 
                                                        {{ master.rate_text }}
                                                    </span>
                                                </div>
                                                <div class="flex items-center my-2">
                                                    <span class="material-icons text-green-600">verified</span>
                                                    <span class="text-green-600 font-bold text-md">Verified Certificates</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="grid ml-4">
                                            <div class="sm:block hidden">
                                                <Link :href="master.profileUrl">
                                                    <h2 class="text-2xl font-bold my-2 text-gray-700">
                                                        {{ master.user?.fullName }}
                                                    </h2>
                                                </Link>
                                                <div>
                                                    <span class="master-level my-2"> 
                                                        {{ master.rate_text }}
                                                    </span>
                                                </div>
                                                <div class="flex items-center my-2">
                                                    <span class="material-icons text-green-600">verified</span>
                                                    <span class="text-green-600 font-bold text-md">Verified Certificates</span>
                                                </div>
                                            </div>
                                            <div class="block my-2">
                                                <div class="my-1" v-for="(index,key) in certificate(master.info)" :key="key">
                                                    <span class="text-gray-600">
                                                        <span> {{ index.value }} </span>
                                                        <span v-if="index.description" class="text-gray-600"> - {{ index.description }} </span>
                                                        <span class="cursor-pointer" @click="openCertificateModal(index)">
                                                            <span class="ml-2 text-green-600"> View </span>
                                                            <i class="align-middle material-icons text-green-500 mx-1 launch-view-font">launch</i>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </figure>
                                </div>

                                <div class="grid grid-flow-row auto-rows-max mx-auto">
                                    <div class="border border-gray-300 rounded-md sm:mt-4 mt-0 sm:py-4 py-2">
                                        <div class="justify-center flex text-lg" v-if="master.online_course_status">
                                            <span class="font-bold text-gray-600">
                                                Online:
                                            </span>
                                            <div class="text-green-600 font-bold mx-1">
                                                {{ master.speciality[master.speciality.length - 1].amount_course }}{{ $page.props.currency }}
                                            </div>
                                            <span class="text-gray-600">
                                                /hour
                                            </span>
                                        </div>
                                        <div class="justify-center flex text-lg" v-if="master.in_person_course_status">
                                            <span class="font-bold text-gray-600">
                                                In-person:
                                            </span>
                                            <div class="text-green-600 font-bold mx-1">
                                                {{ master.in_person_amount_course }}{{ $page.props.currency }}
                                            </div>
                                            <span class="text-gray-600">
                                                /hour
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-center my-2 mb-4">

                                        <span>
                                            <span class="custom-button bg-yellow-400 text-xl shadow-md px-7 py-2 mb-5 rounded-full text-white hover:shadow-xl
                                                transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500 cursor-pointer
                                                google_ads_book_trial_session_master_list"
                                                @click="openFreeConsultation(master)" >
                                                Book a free consultation
                                            </span>
                                        </span>
                                    </div>
                                    <div class="text-center block text-gray-600 flex justify-center mb-4 mt-1">
                                        <div class="w-[240px]">
                                            Have a free 15-minute call with this trainer to see if it’s the right fit.

                                            <span class="tooltip-container">
                                                    <span class="material-icons text-gray-300 inline cursor-pointer mx-1 absolute top-[-17px]" style="font-size: 23px"> help_outline </span>
                                                <span class="tooltip" :style="`text-align:left;`">
                                                    Discuss your fitness goals, ask questions, and learn how the trainer can help you achieve your goals. This call is completely free, with no obligation to book a paid session afterward.
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- <div class="text-gray-600 text-center my-3 font-bold">
                                        "Free Trial Session!"
                                    </div> -->
                                    <!-- <div class="text-center my-3">
                                        <span class="text-gray-500 text-md">
                                            <span v-if="getMasterActiveClientsCount(master.course)"> 
                                                <a class="font-bold "> {{ getMasterActiveClientsCount(master.course) }} </a> 
                                                Active Clients
                                            </span>
                                            <span v-if="getHeldCourseCount(master.course)">
                                                <a class="font-bold"> {{ getHeldCourseCount(master.course) }} </a>
                                                Sessions held
                                            </span>
                                        </span>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                        <div v-if="! isMobile()" class="rounded-2xl shadow-lg bg-white col-span-4 hidden sm:block my-1">
                            <div class="relative cursor-pointer" @click="showMasterVideo(master)">
                                <div class="cursor-pointer text-yellow-400 hover:text-yellow-600">
                                    <span class="material-icons youtube-play z-20">play_circle_filled</span>
                                </div>
                                <img class="rounded-2xl h-[280px] w-full object-cover" :loading="key == 0 ? 'eager' : 'lazy'" :src="master.video_preview_url" alt="Video preview" />
                                <div class="video-preview-backdrop rounded-2xl"></div>
                            </div>
                        </div>
                    </section>
                    
                    <VideoShow :showPlayer="masterVideoSelect.isShowVideo" :video="masterVideoSelect.video" @close="closeMasterVideo"/>

                    <FreeConsultationModal
                        :master="freeConsultationMaster"
                        :show="showFreeConsultationModal"
                        @close="closeFreeConsultation"
                    />

                    <pagination
                        v-if="paginatedLinks"
                        :totalRows="masters.total"
                        :urlsArray="paginatedLinks"
                        :previousPageUrl="masters.prev_page_url"
                        :nextPageUrl="masters.next_page_url"
                    >
                    </pagination>

                    <!--    breadcrumbs       -->

                    <div class="breadcrumb mx-4 mt-2">
                        <div class="breadcrumb-item">
                            <a href="/" class="hover:text-green-500">happytrainers</a>
                        </div>
                        <div v-for="(breadcrumb, key) of breadcrumbs" class="breadcrumb-item">
                            <a v-if="key !== Object.keys(breadcrumbs).length - 1" :href="breadcrumb['url']" class="hover:text-green-500">{{ breadcrumb['name'] }}</a>
                            <span v-else>{{ breadcrumb['name'] }}</span>
                        </div>
                    </div>

                    <div class="sm:mx-auto mx-2 mt-10" v-if="promotionMasters.length > 0">
                        <div class="relative">
                            <div class="px-2 py-2 bg-green-500 text-white border justify-center w-64 rounded-full flex text-xl mx-auto absolute z-10 -top-8 inset-x-0 my-4">
                                Affordable Trainers
                            </div>
                        </div>
                        <div class="pt-10">
                            <agile :autoplay="this.getMasterPromotionSlidesAutoplay()"
                                :options="masterPromotionSwiperOptions"
                                :infinite="this.getMasterPromotionSlidesAutoplay()"
                                :class="(!isMobile() && this.getMasterPromotionSlidesToShow() < 3) ? 'comments-slider-center-mode' : ''"
                            >
                                <div v-for="(masterPromotion,key) in promotionMasters" :key="key">
                                    <div class="rounded bg-white min-h-[395px] mx-1">
                                        <figure class="px-5 py-3 flex flex-col">
                                            <div class="flex justify-start">
                                                <div class="items-center">
                                                    <Link :href="masterPromotion.profileUrl">
                                                        <div class="master-lists-avatar rounded-full mx-auto border ring ring-offset-2 ring-gray-300 shadow-md">
                                                            <img :src="`${masterPromotion.user?.profile_photo_url}?w=160&h=160`"
                                                                :loading="key == 0 ? 'eager' : 'lazy'"
                                                                :alt="`${this.service_category.title} ${masterPromotion.user?.fullName}`"
                                                                width="160"
                                                                height="160"
                                                                class="img-cover rounded-full">
                                                        </div>
                                                    </Link>
                                                </div>
                                                <div class="block ml-3 mt-5">
                                                    <Link :href="masterPromotion.profileUrl">
                                                        <h2 class="text-2xl font-bold my-2 text-gray-700">
                                                            {{ masterPromotion.user?.fullName }}
                                                        </h2>
                                                    </Link>
                                                    <div>
                                                        <span class="master-level my-2"> 
                                                            {{ masterPromotion.rate_text }}
                                                        </span>
                                                    </div>
                                                    <div class="flex items-center my-2">
                                                        <span class="material-icons text-green-600">verified</span>
                                                        <span class="text-green-600 font-bold text-md">Verified Certificates</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="grid ml-4">
                                                <div class="block my-2">
                                                    <div class="my-1" v-for="(index,key) in certificate(masterPromotion.info)" :key="key">
                                                        <span class="text-gray-600">
                                                            <span v-if="index.description">
                                                                {{ promotionMasterTextShorter(`${index.value}-${index.description}`,20) }}
                                                            </span>
                                                            <span v-else> {{ promotionMasterTextShorter(index.value,20) }} </span>
                                                            <span class="cursor-pointer" @click="openCertificateModal(index)">
                                                                <span class="ml-2 text-green-600"> View </span>
                                                                <i class="align-middle material-icons text-green-500 mx-1 launch-view-font">launch</i>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="flex flex-col">
                                                <div class="border border-gray-300 rounded-md mt-0 py-2">
                                                    <div class="justify-center flex text-lg" v-if="masterPromotion.online_course_status">
                                                        <span class="font-bold text-gray-600">
                                                            Online:
                                                        </span>
                                                        <div class="text-green-600 font-bold mx-1">
                                                            {{ masterPromotion.speciality[masterPromotion.speciality.length - 1].amount_course }}{{ $page.props.currency }}
                                                        </div>
                                                        <span class="text-gray-600">
                                                            /hour
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="text-center my-2 mb-3">
                                                    <Link :href="masterPromotion.profileUrl">
                                                        <span class="custom-button bg-yellow-400 text-xl shadow-md px-7 py-2 mb-5 rounded-full text-white hover:shadow-xl
                                                            transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500 cursor-pointer
                                                            google_ads_book_trial_session_master_list">
                                                            Book a free consultation
                                                        </span>
                                                    </Link>
                                                </div>
                                                <div class="flex justify-center items-center gap-2 text-green-500 font-bold mb-3">
                                                    <Link :href="affordableUrl">
                                                        <span>View all affordable trainers</span>
                                                        <i class="align-middle material-icons mx-1 launch-view-font">launch</i>
                                                    </Link>
                                                </div>
                                            </div>
                                        </figure>
                                    </div>
                                </div>
                                <template #prevButton>
                                    <span class="mt-2 material-icons text-gray-400 agile-nav-button cursor-pointer">arrow_circle_left</span>
                                </template>
                                <template #nextButton>
                                    <span class="mt-2 material-icons text-gray-400 agile-nav-button cursor-pointer">arrow_circle_right</span>
                                </template>
                            </agile>
                        </div>
                    </div>

                    <!--    comments        -->
                    <div v-if="(isClientSide())" class="sm:mx-auto mx-2 mt-10">
                        <div class="relative">
                            <div class="px-2 py-2 bg-green-500 text-white border justify-center w-64 rounded-full flex text-xl mx-auto absolute z-10 -top-8 inset-x-0 my-4">
                                Client Reviews
                            </div>
                        </div>
                        <div class="pt-10">
                            <agile :slides-to-show='this.getCommentsSlidesToShow()'
                                :autoplay="this.getCommentsSlidesAutoplay()"
                                :options="swiperOptions"
                                :infinite="this.getCommentsSlidesAutoplay()"
                                :class="(!isMobile() && this.getCommentsSlidesToShow() < 4) ? 'comments-slider-center-mode' : ''"
                            >
                                <div v-for="comment in pageContent.comments" :key="comment.id">
                                    <div class="slide rounded-lg shadow-md bg-white p-3 my-1 mx-2 px-3 min-h-[190px]">
                                        <div class="flex justify-between items-center mb-2">
                                            <div class="flex items-center gap-2">
                                                <img class="w-11 h-11 rounded-full mx-auto" loading="lazy" :src="comment.user?.profile_photo_url " :alt="comment.user?.fullName">
                                                <div class="flex flex-col">
                                                    <span class="font-bold text-base"> {{ comment.user.fullName }} </span>
                                                    <span class="text-xs"> on 
                                                        <Link :href="comment?.master?.profileUrl">
                                                            {{ comment?.master?.user?.fullName }}
                                                        </Link>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="flex items-center justify-center">
                                                <span><i class="material-icons text-yellow-400">star</i></span>
                                                <p class="font-bold text-lg"> {{ comment.avg_score }} </p>
                                            </div>
                                        </div>
                                        <p> {{ convertCommentText(comment) }} </p>
                                        <div v-if="comment.body.length > 220"
                                            class="font-bold text-xs cursor-pointer mt-2" 
                                            @click="comment.showMore = ! comment.showMore"> {{ showMoreCommentText(comment) }}
                                        </div>
                                    </div>
                                </div>
                                <template #prevButton>
                                    <span class="material-icons text-gray-400 agile-nav-button cursor-pointer">arrow_circle_left</span>
                                </template>
                                <template #nextButton>
                                    <span class="material-icons text-gray-400 agile-nav-button cursor-pointer">arrow_circle_right</span>
                                </template>
                            </agile>
                        </div>
                    </div>
                    <!--    category description   -->
                    <div v-if="pageContent && pageContent.footer_title || footer_body" class="text-center place-items-center sm:mx-auto max-w-screen-xl relative">
                        <div class="px-2 py-2 bg-green-500 text-white border  w-80 sm:w-[500px] rounded-full text-xl mx-auto mt-3 absolute z-10 -top-8 inset-x-0 my-6 sm:my-4">
                            {{ pageContent.footer_title }}
                        </div>
                        <div class="rounded-2xl shadow-xl bg-white pt-[55px] sm:pt-[30px] pb-9 px-9 border mx-2 mt-10 max-w-screen-xl">
                            <p class="text-justify mt-4 " v-html="pageContent ? pageContent.footer_body : null"></p>
                        </div>
                    </div>
                    <!--    FAQ   -->
                    <article v-if="pageContent && pageContent.faq && pageContent.faq.length > 0 " class="text-center place-items-center mx-2 sm:mx-auto max-w-screen-xl relative">
                        <div class="px-2 py-2 bg-green-500 text-white border justify-center w-64 rounded-full flex text-xl mx-auto absolute z-10 -top-8 inset-x-0 my-4">
                            FAQ
                            <span class="material-icons text-white ml-1">help_outline</span>
                        </div>

                        <div class="rounded-2xl shadow-xl bg-white sm:p-9 p-2 pt-9 mt-6 border mt-10 max-w-screen-xl">
                            <div v-for="(item,key) in pageContent.faq" :key="key" class="mt-2">
                                <div @click="faqIndex===item.id ? faqIndex=null : faqIndex=item.id"
                                     :class="{'border border-yellow-400': faqIndex===item.id  }"
                                     class="border border-gray-300 cursor-pointer rounded-full sm:p-3 p-1 justify-between flex">
                                    <div class="flex items-center">
                                        <span class="material-icons text-green-600">help</span>
                                        <h2 class="ml-3 break-words text-justify text-[11pt] font-bold">{{ item.question }}</h2>
                                    </div>
                                    <!-- <div class="sm:mr-4">
                                        <span v-if="faqIndex===item.id" class="material-icons">keyboard_arrow_up</span>
                                        <span v-else class="material-icons">expand_more</span>
                                    </div> -->
                                </div>
                                <!-- <div v-show="faqIndex===item.id" class="sm:p-5 p-2 mt-2 border border-gray-300 sm:mx-4 rounded-lg transition"> -->
                                <div class="p-2 border border-gray-300 sm:mx-4 rounded-lg transition">

                                    <p class="ml-3 break-words text-justify" v-html="item.answer"></p>
                                </div>
                            </div>
                        </div>
                    </article>
                    <!--    find a trainer   -->
                    <div class="text-center place-items-center sm:mx-auto max-w-screen-xl relative mb-4">
                        <div class="px-2 py-2 bg-green-500 text-white border w-64 rounded-full text-xl mx-auto absolute z-10 -top-8 inset-x-0 my-4">
                            Find a trainer in your city
                        </div>
                        <div class="rounded-2xl shadow-xl bg-white p-9 border mx-2 mt-10 max-w-screen-xl flex flex-wrap">
                            <div v-for="(link,key) in pageContent.links"
                                 :key="key"
                                 class="rounded-2xl px-2 py-2 border border-gray-200 mt-1 shadow-md m-1 hover:shadow-xl transition duration-500 ease-in-out">
                                <Link :href="`${link.href}`"
                                      class="hover:text-indigo-500">
                                    {{ link.title }}
                                </Link>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            <jet-confirmation-modal v-if="showCertificateModal">
                <template #content>
                    <iframe
                        v-if="isCertificatePdf(modalInfo)" 
                        :src="modalInfo.fileUrl"
                        class="w-full"
                        height="500"
                    />
                    <img v-else class="w-full" :src="modalInfo.fileUrl" :alt="modalInfo.value" />
                    <div class="text-center text-lg text-gray-600 my-3 font-bold">
                        {{ modalInfo.value}}
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-center">
                        <button class="gold-btn" @click="closeCertificateModal">
                            Go Back
                        </button>
                    </div>
                </template>
            </jet-confirmation-modal>

            <!-- master Schedule -->
            <jet-confirmation-modal v-if="CourseDialog" @close="CourseDialog=false">
                <template #title>Course Reservation</template>
                <template #content>
                    <div v-show="$page.props.error" class="text-center mb-4 font-medium text-sm bg-red-100 p-4 text-red-600 rounded-md">
                        <span>{{$page.props.error}}</span>
                    </div>
                    <div class="sm:p-3 p-0 date-picker" dir="ltr">
                        <div v-if="showSchedule()">
                            <FrontSchedule :date="JSON.parse(selectedMaster.schedule)"
                                        :start_date="selectedMaster.start_time"
                                        :end_date="selectedMaster.end_time"
                                        :holiday="selectedMaster.holiday"
                                        :busy_time="selectedMaster.course"
                                        :day_valid="selectedMaster.day_valid"
                                        :minute_shift="selectedMaster.course_time"
                                        :time_zone="selectedMaster.time_zone || 'America/Toronto'"
                                        :timezoneLists="timezoneLists"
                                        @input="setSelectedDate"
                            />
                        </div>
                        <div v-else>
                            <div class="text-center text-red-500">
                                Activity schedule not specified
                            </div>
                        </div>
                    </div>
                </template>
                <template #footer>
                    <button v-if="showSchedule()" class="gold-btn" @click="booking">
                        Book your session
                    </button>
                    <jet-secondary-button class="ml-2" @click="CourseDialog = false">
                        cancel
                    </jet-secondary-button>
                </template>
            </jet-confirmation-modal>

            <jet-confirmation-modal v-if="checkMobile" @close="closeCheckMobil" maxWidth="xl">
                <template #content>
                    <div class="text-left mx-2">
                        <div class="p-4">
                            <h3 v-if="isUser" class="text-4xl text-gray-600 font-bold">Login</h3>
                            <h3 v-if="showCodeBox" class="text-4xl text-gray-600 font-bold">SignUp</h3>
                            
                            <div class="my-2">
                            <span v-if="$page.props.modalError">
                                <a class="sm:text-lg text-[14px] bg-red-100 text-red-600 py-1 px-3 rounded-lg"> {{ $page.props.modalError }}! </a>
                                <p v-if="!showCodeBox" class="text-indigo-500" href="/forgot-password">Forgot your password?</p>
                            </span>
                            </div>
                            <jet-label v-if="!isUser && !showCodeBox" for="Mobile" class="mb-3" value="Please enter your email address:" />
                            <jet-label for="Email" value="Email" />
                            <input type="text"
                                v-model="mobile"
                                placeholder="test@gmail.com"
                                :disabled="isUser || showCodeBox ? true : false"
                                class="shadow-sm my-3 focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md border">
                            <jet-input-error 
                                v-if="$page.props.errorBags?.mobileConfirmForm" 
                                :message="$page.props.errorBags?.mobileConfirmForm['mobile']"             
                                class="mt-2"/>
                            <div v-if="isUser || showCodeBox">
                                <jet-label 
                                    for="Mobile" 
                                    value="Password"
                                />
                                <input 
                                    type="password"
                                    class="shadow-sm my-3 focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md border"
                                    v-model="password"
                                    placeholder="password"
                                >
                                <jet-input-error 
                                    v-if="$page.props.errorBags?.mobileConfirmForm" 
                                    :message="$page.props.errorBags?.mobileConfirmForm['password']"
                                    class="mt-2"/>
                            </div>

                            <div class="text-center mt-3">
                                <span class="text-red-500 text-sm" v-html="msg"></span>
                            </div>

                            <jet-label for="terms" class="mt-4" v-if="showCodeBox">
                                <div class="flex items-center">
                                    <jet-checkbox name="terms" id="terms" v-model="terms"/>
                                    <div class="ml-2">
                                        By using this website or signing up, you agree to Happy Trainers <a target="_blank" href="/term-of-service"
                                        class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and 
                                        <a target="_blank" href="/privacy-policy" class="underline text-sm text-gray-600 hover:text-gray-900">
                                        Privacy Policy</a>
                                    </div>
                                </div>
                            </jet-label>
                        </div>
                        <div class="text-center px-5">
                            <button 
                                v-if="!isUser && !showCodeBox" 
                                class="my-1 w-full gold-btn text-base"
                                @click="checkUser()" 
                                :disabled="disabledButton"
                                >Proceed to sign up or log in
                            </button>
                            <button 
                                v-if="showCodeBox" 
                                class="my-1 w-full gold-btn text-base"
                                @click="checkCode()" :disabled="disabledButton"> Sign up
                            </button>
                            <button 
                                v-if="isUser" 
                                class="my-1 gold-btn w-full text-base"
                                    @click="login">Log in
                            </button>
                            <button 
                                v-if="isUser" 
                                class="my-1 gold-btn bg-gray-400 w-full text-base"
                                style="background-color:#ebd371 !important"
                                @click="forgotPassword">Forgot password
                            </button>
                            <button 
                                class="my-1 w-full gold-btn bg-gray-400 p-1 px-4 text-base"
                                style="background-color:#dddddd !important"
                                @click="closeCheckMobil">close
                            </button>
                            
                            <!-- <div class="relative flex py-5 items-center">
                                <div class="flex-grow" style="border:1px solid #e7e2e2"></div>
                                <span class="flex-shrink mx-4 text-gray-400">Or</span>
                                <div class="flex-grow" style="border:1px solid #e7e2e2"></div>
                            </div>
                            
                            <google-auth /> -->
                        </div>
                    </div>
                </template>
            </jet-confirmation-modal>

            <MasterScheduleType
                :master="selectedMaster"
                :show="showScheduleTypeModal"
                @select="selectScheduleType"
                @close="closeScheduleTypeModal"
            />
        </template>
    </main-site>
</template>

<script>

let Agile;
if (typeof window !== "undefined" && typeof document !== "undefined") {
    Agile = require('vue-agile').VueAgile;
}
import Select from "@/Jetstream/Select";
import Label from "@/Jetstream/Label";
import Input from "@/Jetstream/Input";
import Pagination from "@/Pages/Dashboard/Components/Pagination";
import myMixin from "@/myMixin";
import MainSite from '@/Pages/Components/MainSite'
import {Link, InertiaHead} from '@inertiajs/inertia-vue3';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import MasterScheduleMethods from "./components/MasterScheduleMethods.vue";
import FrontSchedule from "@/Pages/Components/FrontSchedule";
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetInputError from '@/Jetstream/InputError';
import JetCheckbox from '@/Jetstream/Checkbox';
import JetLabel from "@/Jetstream/Label";
import GoogleAuth from "@/Components/Auth/GoogleAuth";
import Loading from "@/Jetstream/Loading";
import MasterScheduleType from "@/Pages/Components/MasterScheduleType.vue";
import VideoShow from "@/Jetstream/VideoShow";
import VSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import FreeConsultationModal from "@/Pages/Components/FreeConsultationModal.vue";

export default {
    extends: MasterScheduleMethods,
    name: "MasterList",
    mixins: [myMixin],
    props: {
        cities: Array,
        masters: Array,
        range_amount: Array,
        service_category: Array,
        city: Object,
        seo: Array,
        pageContent: Array,
        canonicalLink: String,
        paginatedLinks: Array,
        breadcrumbs: Array,
        timezoneLists: Array,
        affordableUrl: String,
        promotionMasters: Array,
    },
    components: {
        VSelect,
        Input,
        Select, 
        Label,
        MainSite,
        Link,
        agile: Agile,
        InertiaHead,
        Pagination,
        JetConfirmationModal,
        FrontSchedule,
        JetSecondaryButton,
        JetCheckbox,
        JetInputError,
        JetLabel,
        GoogleAuth,
        Loading,
        MasterScheduleType,
        VideoShow,
        FreeConsultationModal
    },
    data() {
        return {
            showCertificateModal: false,
            modalInfo: {},
            pageTitle: "",
            showMore: false,
            play: null,
            faqIndex: null,
            masters: this.masters,
            paginatedLinks: this.paginatedLinks,
            service_category: this.service_category,
            swiperOptions: {
                navButtons: true,
                // responsive: [
                //     {
                //         breakpoint: 600,
                //         settings: {
                //             navButtons: false,
                //         }
                //     }
                // ]
            },
            masterPromotionSwiperOptions: {
                navButtons: true,
                slidesToShow: 1,
				responsive: [
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            },
            masterSortForm: this.$inertia.form({
                '_method': 'POST',
                category: null,
                price: null,
                gender: 'both',
                city: null,
            }),
            masterVideoSelect: {},
            freeConsultationMaster: null,
            showFreeConsultationModal: false,
        }
    },
    mounted() {
        this.setQuery();
    },
    computed: {
        showMoreText() {
            return this.showMore ? ' Hide' : ' Read More';
        },
        pageContentHeaderBody() {
            if (!this.pageContent) return null;
            if(this.showMore){
                return this.pageContent.header_body;
            }
            return this.textShorter(this.pageContent.header_body, 100);
            // let a = 'Read More';
            // let fullText = this.pageContent.header_body;
            // fullText = fullText.slice(0, 200).concat("<div style='display:none'>", fullText.slice(200));
            // fullText += "</div>";
            // console.log('after edit', fullText);
            // return fullText;
        }
    },
    methods: {
        openFreeConsultation(_master){
            this.showFreeConsultationModal = true;
            this.freeConsultationMaster = _master;
        },
        closeFreeConsultation(){
            this.showFreeConsultationModal = false;
            this.freeConsultationMaster = null;
        },
        customCityFilterPattern(option, search, label){      
            if (!search) {
                return true; // Show all options if no search input
            }

            let result = option.filter( function(item){
                let title = item.title;
                if(title){
                    if(title.toLowerCase().startsWith(search.toLowerCase())){
                        return item;
                    }
                }
            });

            return result;
        },
        vSelectLabel(_option){
            let stateShortTitle = ``;
            if(_option && _option.state && _option.state.short_title)
                stateShortTitle = _option.state.short_title;
            return `${_option.title} ${stateShortTitle}`;
        },
        promotionMasterTextShorter(_text, _length){
            if(_text.length <= _length){
                return _text;
            }
            return this.textShorter(_text, _length);
        },
        showMasterVideo(_master){
            _master.isShowVideo = true;
            this.masterVideoSelect = _master;
        },
        closeMasterVideo(_master){
            this.masterVideoSelect.isShowVideo = false;
            this.masterVideoSelect = {};
        },
        convertCommentText(_comment) {
            if (_comment.showMore) {
                return _comment.body;
            }
            return _comment.body.length > 220 ? this.textShorter(_comment.body, 200) : _comment.body;
        },
        showMoreCommentText(_comment) {
            return _comment.showMore ? ' Hide' : ' Read More';
        },
        forgotPassword() {
            window.location.href = route('password.request');
        },
        closeCertificateModal() {
            this.showCertificateModal = false;
            this.modalInfo = {};
        },
        openCertificateModal(_info) {
            if( this.isMobile() && this.isCertificatePdf(_info)){
                return window.open(_info.fileUrl);
            }
            this.showCertificateModal = true;
            this.modalInfo = _info;
        },
        isCertificatePdf(_info){
            return _info.fileUrl.includes('.pdf') ? true : false;
        },
        getCategoryData() {
            if (process.browser && typeof this.$page !== "undefined") {
                let catUrl = this.$page.props.categories.find(item => item.id === this.masterSortForm.category).url;

                const gender = (this.masterSortForm.gender && this.masterSortForm.gender !== 'both') ? this.masterSortForm.gender : null;

                const url = `/${catUrl}${this.masterSortForm.city ? '/' + this.masterSortForm.city : '/online'}${gender ? '?gender=' + gender : ''}`;

                this.$inertia.get(url)
            }
        },
        changed_url: function (url) {
            this.setPageUrl(url);
        },
        getActiveCourse(course) {
            let count = 0
            for (let item of course) {
                if (item.status === 1 && item.chosen_date < new Date().toDateString()) {
                    count++
                }
            }
            return count
        },
        setQuery() {
            if (typeof window !== "undefined" && typeof this.$page !== "undefined") {

                const gender = this.getParam('gender') ?? 'both';

                this.masterSortForm.gender = gender;

                let category = this.$page.props.categories.find(item => item.url === this.service_category.url);
                if (this.city && this.city.id)
                    var city = this.$page.props.cities.find(item => item.id === this.city.id);
                setTimeout(() => {
                    this.masterSortForm.category = category.id;
                    if (this.city && this.city.id) this.masterSortForm.city = city.url;
                    if (!this.city) this.pageTitle = `Online ${category.title}`;
                    if (this.city && this.city.id) this.pageTitle = `${category.title} Near Me in ${city.title}`;
                }, 50);
            }
        },
        getRangePrice() {
            let amountRange = []
            const range = this.range_amount['max'] / this.range_amount['min'] * 10
            for (let item = this.range_amount['min']; item <= this.range_amount['max'];) {
                amountRange.push(item)
                item = item + range
            }
            return amountRange
        },
        showMoreButton() {
            this.showMore = !this.showMore;
        },
        getCommentsSlidesToShow() {
            const count = this.pageContent.comments ? this.pageContent.comments.length : 0;

            if (this.isMobile()) {
                return 1;
            }

            return (count > 4) ? 4 : count;
        },
        getMasterPromotionSlidesToShow() {
            const count = this.promotionMasters ? this.promotionMasters.length : 0;

            if (this.isMobile()) {
                return 1;
            }

            return (count > 3) ? 3 : count;
        },
        getCommentsSlidesAutoplay() {
            const count = this.pageContent.comments ? this.pageContent.comments.length : 0;

            return (count > 4);
        },
        getMasterPromotionSlidesAutoplay() {
            const count = this.promotionMasters ? this.promotionMasters.length : 0;
            return (count > 3);
        }
    }
}
</script>

<style scoped>
.pagecontent-header-body {
    font-weight: 300 !important;
    font-size: 14px !important;
}

.show-more-button {
    cursor: pointer;
    border-radius: 5px;
    background: #ddfdda;
    padding: 3px;
    color: #000000;
}

.plyr {
    border-radius: 1rem;
}

.comments-slider-center-mode .agile__slide {
    max-width: 450px;
}

.master-lists-avatar {
    width: 160px;
    min-width: 160px;
    max-width: 160px;
    height: 160px;
    min-height: 160px;
    max-height: 160px;
}
</style>
<style>

/* Target specific classes from vue-select to apply custom styles */
.vs__dropdown-toggle {
    border-radius: 20px !important;
    padding: 3px !important;
    height: 43px !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.vs__selected {
    font-size: 16px !important;
}
</style>